import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import logger from '@ieShared/utils/logger.utils';

bootstrapApplication(AppComponent, appConfig).catch((err) => logger.error(err));
